import axiosInstance from './axios';
import { API_URL } from '../config/api';

export const accessoryService = {
  getAccessories: () => axiosInstance.get(`/api/accessories`),
  createAccessory: (data) => axiosInstance.post(`/api/accessories`, data),
  updateAccessory: (id, data) => axiosInstance.put(`/api/accessories/${id}`, data),
  deleteAccessory: (id) => axiosInstance.delete(`/api/accessories/${id}`)
};
